import React, { Component } from 'react';
import { GlobalContext } from '../../interfaces/GlobalContext/GlobalContext';
import ChoiceMessageProps from './ChoiceMessage.props';
import ChoiceMessageState from './ChoiceMessage.state';

export default class ChoiceMessage extends Component<ChoiceMessageProps, ChoiceMessageState> {
    static contextType = GlobalContext;
    context!: React.ContextType<typeof GlobalContext>;

    constructor(props: ChoiceMessageProps) {
        super(props);
        this.state = {
            key: 'value'
        };
    }

    render(): React.ReactNode {
        return (
            <div className="choice-message">
                <h2 className="choice-message__title">
                    { this.context.i18nProvider.get('checkDataPage.usp.headline') || "" }
                </h2>
                <div className="choice-message__wrapper">
                    <div className="choice-message__content">
                        <span className="icon_check choice-message__content-icon"></span>
                        <div className="choice-message__content-body">
                            <div className="choice-message__content-body-title">
                                <span>{ this.context.i18nProvider.get('checkDataPage.usp.uspContentFirst.headline') || "" }</span>
                            </div>
                            <div className="choice-message__content-body-text" 
                                dangerouslySetInnerHTML={{ __html: this.context.i18nProvider.get('checkDataPage.usp.uspContentFirst.description') || "" 
                                }}>
                            </div>
                        </div>
                    </div>
                    <div className="choice-message__content">
                        <span className="icon_check choice-message__content-icon"></span>
                        <div className="choice-message__content-body">
                            <div className="choice-message__content-body-title">
                                <span>{ this.context.i18nProvider.get('checkDataPage.usp.uspContentSecond.headline') || "" }</span>
                            </div>
                            <div className="choice-message__content-body-text" 
                                dangerouslySetInnerHTML={{ __html: this.context.i18nProvider.get('checkDataPage.usp.uspContentSecond.description') || "" 
                                }}>
                            </div>
                        </div>
                    </div>
                    <div className="choice-message__content">
                        <span className="icon_check choice-message__content-icon"></span>
                        <div className="choice-message__content-body">
                            <div className="choice-message__content-body-title">
                                <span>{ this.context.i18nProvider.get('checkDataPage.usp.uspContentThird.headline') || "" }</span>
                            </div>
                            <div className="choice-message__content-body-text" 
                                dangerouslySetInnerHTML={{ __html: this.context.i18nProvider.get('checkDataPage.usp.uspContentThird.description') || "" 
                                }}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
